module.exports = __webpack_public_path__ + "static/show-your-work-c1d00f905633846d1fea20d3d2c12469.jpg";